import { formatWeight, formatDateTime } from './helpers';

function coerceWeighInstant(raw) {
  if (raw == null || raw === '') return null;
  const d = raw instanceof Date ? raw : new Date(raw);
  if (Number.isNaN(d.getTime())) return null;
  return d;
}

function formatWeighInstantForRow(raw, t) {
  const d = coerceWeighInstant(raw);
  if (!d) return t('loads.modal.weighDateUnknown');
  try {
    const s = formatDateTime(d);
    return s && String(s).trim() ? s : t('loads.modal.weighDateUnknown');
  } catch {
    return t('loads.modal.weighDateUnknown');
  }
}

/**
 * Build rows for listing each weighing pass (tare, then gross/loaded) with date/time.
 * Used in load detail UIs before the weight summary grid.
 *
 * @param {object|null|undefined} load
 * @param {import('i18next').TFunction} t
 * @returns {{ key: string, label: string, weight: string, date: string }[]}
 */
export function buildLoadWeighPassListing(load, t) {
  if (!load) return [];

  const rows = [];
  const loadTareKg =
    load.emptyWeight != null && load.emptyWeight !== ''
      ? Number(load.emptyWeight)
      : null;
  const truckTareKg =
    load.truck?.emptyWeight != null && load.truck?.emptyWeight !== ''
      ? Number(load.truck.emptyWeight)
      : null;
  const tareKg =
    loadTareKg != null && Number.isFinite(loadTareKg)
      ? loadTareKg
      : truckTareKg != null && Number.isFinite(truckTareKg)
        ? truckTareKg
        : null;

  if (tareKg != null && Number.isFinite(tareKg)) {
    const atRaw = load.tareWeighedAt ?? load.tare_weighed_at ?? load.loadDate;
    rows.push({
      key: 'tare',
      label: t('loads.modal.passListingTare'),
      weight: formatWeight(tareKg, 'ton', { noUnit: true }) || '—',
      date: formatWeighInstantForRow(atRaw, t)
    });
  }

  const lw = load.loadedWeight;
  if (lw != null && lw !== '' && Number.isFinite(Number(lw))) {
    // Prefer explicit instant; legacy rows / manager edits may only have loadDate (same as certificates when loadedWeighedAt is null).
    const atRaw =
      load.loadedWeighedAt ??
      load.loaded_weighed_at ??
      load.loadDate;
    rows.push({
      key: 'brut',
      label: t('loads.modal.passListingBrut'),
      weight: formatWeight(Number(lw), 'ton', { noUnit: true }) || '—',
      date: formatWeighInstantForRow(atRaw, t)
    });
  }

  return rows;
}
